var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "freeze",
      style: _vm.currentIndex != 0 && !_vm.$isFlag ? "background:#fff" : ""
    },
    [
      _c("header-item", {
        attrs: {
          "title-array": _vm.titleArray,
          "is-show": true,
          "title-mb": _vm.titleArray[0],
          "type-next": "click"
        },
        on: { navBarClick: _vm.navBarClick }
      }),
      _c(
        "div",
        { staticClass: "lt-freeze-form", on: { submit: _vm.handleSubmit } },
        [
          _c(
            "van-form",
            { staticClass: "appealInfo" },
            [
              _c("van-field", {
                staticClass: "radio",
                staticStyle: { "border-radius": "16px 16px 0 0" },
                attrs: {
                  name: "sys",
                  label: "操作系统：",
                  rules: [{ required: true, message: "请选择操作系统" }],
                  required: ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function() {
                      return [
                        _c(
                          "van-radio-group",
                          {
                            attrs: { direction: "horizontal" },
                            model: {
                              value: _vm.freezeParams.sys,
                              callback: function($$v) {
                                _vm.$set(_vm.freezeParams, "sys", $$v)
                              },
                              expression: "freezeParams.sys"
                            }
                          },
                          [
                            _c("van-radio", { attrs: { name: "110001" } }, [
                              _vm._v("安卓官方")
                            ]),
                            _c("van-radio", { attrs: { name: "210009" } }, [
                              _vm._v("雷霆iOS")
                            ]),
                            _c("van-radio", { attrs: { name: "150001" } }, [
                              _vm._v("鸿蒙官方")
                            ])
                          ],
                          1
                        )
                      ]
                    },
                    proxy: true
                  }
                ])
              }),
              _c("van-field", {
                staticClass: "lt-freeze-select",
                attrs: {
                  name: "gameCode",
                  label: "选择游戏：",
                  required: "",
                  rules: [{ required: true, message: "" }]
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function() {
                      return [
                        _c("common-select", {
                          attrs: {
                            "selection-info": {
                              selectName: "",
                              columns: _vm.gameList,
                              label: "gameName",
                              val: "gameCode"
                            }
                          },
                          on: { emitParentVal: _vm.emitGameCode }
                        })
                      ]
                    },
                    proxy: true
                  }
                ])
              }),
              _c("van-field", {
                staticClass: "lt-freeze-select",
                attrs: {
                  name: "zoneId",
                  label: "游戏区组：",
                  required: "",
                  rules: [{ required: true, message: "" }]
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function() {
                      return [
                        _c("common-select", {
                          ref: "zoneSelect",
                          attrs: {
                            "selection-info": {
                              selectName: "",
                              columns: _vm.zoneList,
                              label: "zoneName",
                              val: "zoneId"
                            }
                          },
                          on: { emitParentVal: _vm.emitZoneId }
                        })
                      ]
                    },
                    proxy: true
                  }
                ])
              }),
              _c("van-field", {
                attrs: {
                  label: "雷霆账号：",
                  required: "",
                  rules: [{ required: true, message: "不可为空" }]
                },
                model: {
                  value: _vm.freezeParams.account,
                  callback: function($$v) {
                    _vm.$set(_vm.freezeParams, "account", $$v)
                  },
                  expression: "freezeParams.account"
                }
              }),
              _c("van-field", {
                staticClass: "van-field__label_wrap",
                attrs: {
                  label: "您的姓名（账号注册时填写的姓名）：",
                  required: "",
                  rules: [{ required: true, message: "不可为空" }],
                  placeholder: "账号注册时填写的姓名"
                },
                model: {
                  value: _vm.freezeParams.name,
                  callback: function($$v) {
                    _vm.$set(_vm.freezeParams, "name", $$v)
                  },
                  expression: "freezeParams.name"
                }
              }),
              _c("van-field", {
                staticClass: "van-field__label_wrap",
                attrs: {
                  label: "身份证号码（账号注册时填写的身份证号码）：",
                  required: "",
                  name: "idCard",
                  rules: _vm.rules.idRules,
                  placeholder: "账号注册时填写的身份证号码"
                },
                model: {
                  value: _vm.freezeParams.idCard,
                  callback: function($$v) {
                    _vm.$set(_vm.freezeParams, "idCard", $$v)
                  },
                  expression: "freezeParams.idCard"
                }
              }),
              _c("van-field", {
                staticClass: "van-field__label_wrap",
                attrs: {
                  label: "曾用手机号（7天内账号曾经使用过的绑定手机号）：",
                  required: "",
                  rules: _vm.rules.mobileRules,
                  placeholder: "7天内账号曾经使用过的绑定手机号"
                },
                model: {
                  value: _vm.freezeParams.phone,
                  callback: function($$v) {
                    _vm.$set(_vm.freezeParams, "phone", $$v)
                  },
                  expression: "freezeParams.phone"
                }
              }),
              _c("van-field", {
                staticStyle: { "border-radius": "0 0 16px 16px" },
                attrs: {
                  label: "短信验证码：",
                  maxlength: "6",
                  required: "",
                  rules: _vm.rules.codeRules,
                  placeholder: "请输入验证码"
                },
                scopedSlots: _vm._u([
                  {
                    key: "button",
                    fn: function() {
                      return [
                        !_vm.showTime
                          ? _c(
                              "p",
                              {
                                staticStyle: {
                                  color: "#616edf",
                                  cursor: "pointer"
                                },
                                on: { click: _vm.getCode }
                              },
                              [_vm._v(_vm._s(_vm.timeMsg))]
                            )
                          : _c(
                              "p",
                              {
                                staticStyle: {
                                  color: "#878787",
                                  cursor: "pointer"
                                }
                              },
                              [_vm._v(_vm._s(_vm.codeTime) + " S")]
                            )
                      ]
                    },
                    proxy: true
                  }
                ]),
                model: {
                  value: _vm.freezeParams.phoneCode,
                  callback: function($$v) {
                    _vm.$set(_vm.freezeParams, "phoneCode", $$v)
                  },
                  expression: "freezeParams.phoneCode"
                }
              }),
              _c("p", { staticClass: "reg_p" }, [
                _vm._v("*如果一分钟内没有收到验证码请重新获取")
              ]),
              _c(
                "div",
                { staticClass: "bottom" },
                [
                  _c(
                    "van-button",
                    {
                      staticClass: "formClass_btn",
                      attrs: {
                        round: "",
                        block: "",
                        type: "info",
                        color: "#616edf"
                      },
                      on: { click: _vm.handleSubmit }
                    },
                    [_vm._v("申请冻结")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._m(0)
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "lt-freeze-description" }, [
      _c("h4", [_vm._v("查询说明：")]),
      _c("p", [
        _vm._v(
          "1、本页面功能仅限官方iOS、官方安卓、官方鸿蒙区组，渠道区组暂不支持查询"
        )
      ]),
      _c("p", [
        _vm._v(
          "2、申请保护性冻结账号必须是已完善账号有效证件号码且账号的绑定手机7天内存在更改情况"
        )
      ]),
      _c("p", [
        _vm._v(
          "3、曾用手机号为7天内曾经使用过的绑定手机号（不包含通过申诉重置的绑定手机号和当前绑定手机号，若是当前绑定手机号仍可使用，"
        ),
        _c(
          "a",
          {
            attrs: {
              href:
                "https://id.leiting.com/accountCenter/accountSelf/findPassWord"
            }
          },
          [_vm._v("点击这里")]
        ),
        _vm._v("修改密码即可）")
      ]),
      _c("p", [
        _vm._v("4、账号30天内只能申请一次保护性冻结，请妥善保管账号信息")
      ]),
      _c("p", [_vm._v("5、已被封停账号无法进行申请保护性冻结")]),
      _c("p", [
        _vm._v(
          "6、账号保护性冻结时长为永久，冻结后需要通过账号申诉后，重置并绑定手机号码方可申请解冻，申诉失败或未审核前无法解冻， "
        ),
        _c("a", { attrs: { href: "https://lt0.site/ezD4O0" } }, [
          _vm._v("点击这里")
        ]),
        _vm._v("账号申诉 ")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }